import { useEffect, useRef, useState } from "react";

const Grid = ({ items, teasers, labels, columns }) => {
  const containerRef = useRef(null);
  const panelsRef = useRef([]);
  const [imagesLoaded, setImagesLoaded] = useState(false);

  const [visibleSections, setVisibleSections] = useState(3);
  const remToPx = parseFloat(
    getComputedStyle(document.documentElement).fontSize,
  ); // Convert rem to px

  const [stickyInfo, setStickyInfo] = useState(null);
  const [gap, setGap] = useState(6 * remToPx);

  const [lottie, setLottie] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    if (containerRef.current) {
      setStickyInfo(
        containerRef.current
          .closest(".paragraph--type--layout")
          .getElementsByClassName("overview-info")[0],
      );

      let temp = containerRef.current
        .closest(".paragraph--type--layout")
        .querySelector("#lottie-animated-carrousel");

      if (temp) {
        setLottie(temp);
      }
    }
  }, []);

  useEffect(() => {
    const updateVisibleSections = () => {
      const width = window.innerWidth;
      let localGap = 6;
      if (width <= 1000) {
        localGap = 2;
        setVisibleSections(1); // Mobile
      } else if (width <= 1280) {
        setVisibleSections(2); // Tablet
      } else {
        setVisibleSections(2); // Desktop
      }
      setGap(localGap * remToPx);
    };

    updateVisibleSections();
    window.addEventListener("resize", updateVisibleSections);

    return () => {
      window.removeEventListener("resize", updateVisibleSections);
    };
  }, []);

  const [sectionWidth, setSectionWidth] = useState(0);

  useEffect(() => {
    if (imagesLoaded) {
      const sections = panelsRef.current;

      const initScrollTrigger = () => {
        if (
          containerRef.current &&
          !window.matchMedia("(pointer: coarse)").matches
        ) {
          const gsap = window.gsap;
          const ScrollTrigger = window.ScrollTrigger;

          gsap.registerPlugin(ScrollTrigger);

          const sectionCount = sections.length;
          const containerWidth = containerRef.current.offsetWidth;

          let temp = visibleSections;

          if (window.innerWidth < 1700) {
          // temp -= 1;
          }

          
            let sectionWidth = (window.innerWidth) / 3;

            if (window.innerWidth > 1800 || window.innerWidth < 1024) {

    
          sectionWidth =
            (containerWidth - gap * (temp - 1) + 2 * gap) /
            visibleSections;

            }

           
          setSectionWidth(sectionWidth);
          let totalScrollWidth =
            sectionWidth * sectionCount + gap * (sectionCount - 1);

            if (sectionCount <= 2) {
              totalScrollWidth = containerWidth;
            }


          let xPercent =
            -(
              ((sectionCount - temp) * (sectionWidth + gap)) /
              containerWidth
            ) * 100;


         //   xPercent += 40;

          const width = window.innerWidth;
          let start = 65;
          if (width <= 1000) {
            start = 80;
          }

          start  = 50;

          let percentage = 0;

          if (stickyInfo) {
              const elementHeight = stickyInfo.getBoundingClientRect().height;
              const windowHeight = window.innerHeight;
              percentage = ((elementHeight / windowHeight) * 100)  ;
          }
     
     

  
        if (percentage < 20) {
          start = "50";
        } else {
          start = 100-(percentage+10);
        }
      

          gsap.killTweensOf(containerRef.current);
          gsap.to(containerRef.current, {
            xPercent: xPercent,
            ease: "power2.out",
            scrollTrigger: {
              trigger: containerRef.current,
              start: "center " + start + "%",
              end: `+=${totalScrollWidth - containerWidth}`,
              pin: true,
              scrub: 1,
     
              onUpdate: (self) => {
                if (lottie) {
                  if (self.progress === 0 || self.progress >= 1) {
                    lottie.pause();
                  } else {
                    if (!isPlaying) {
                      lottie.play();
                      setIsPlaying(true);
                    }
                  }
                }

                if (stickyInfo) {
               
                  if (self.progress >= 1) {
            
                    stickyInfo.classList.add("outside");
  
                  } else {
                    stickyInfo.classList.remove("sticky");
                       stickyInfo.classList.remove("outside");
   
                  }
                }
              },
            },
          });

          ScrollTrigger.refresh();
        }
      };

      const timeout = setTimeout(() => {
        initScrollTrigger();
      }, 1000);

      const handleResize = () => {
        if (!window.matchMedia("(pointer: coarse)").matches) {
          window.location = window.location;
        }
        setImagesLoaded(0);
        initScrollTrigger();
      };

      window.addEventListener("resize", handleResize);
      return () => {
        clearTimeout(timeout);
        window.removeEventListener("resize", initScrollTrigger);
      };
    }
  }, [columns, visibleSections, gap, imagesLoaded]);

  const shuffleArray = (array) => {
    const shuffled = array.slice();
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  const [shuffledItems, setShuffledItems] = useState([]);

  useEffect(() => {
    if (!shuffledItems.length && items) {
      console.log("shuffle");
      setShuffledItems(shuffleArray(items).slice(0, 3));
    }
  }, [items, shuffledItems]);

  useEffect(() => {
    const checkImages = () => {
      const container = document.querySelector(".output-animated_carrousel");

      // Select all images within the container
      const images = container
        ? Array.from(container.querySelectorAll("img"))
        : [];

     
      const totalImages = images.length;
      let loadedImages = 0;

      const checkAllImagesLoaded = () => {
        loadedImages += 1;

        if (loadedImages === totalImages) {
        
          setImagesLoaded(true);
        }
      };

      images.forEach((img) => {
        if (img.complete) {
          checkAllImagesLoaded();
        } else {
          img.addEventListener("load", checkAllImagesLoaded);
          img.addEventListener("error", checkAllImagesLoaded);
        }
      });

      return () => {
        images.forEach((img) => {
          img.removeEventListener("load", checkAllImagesLoaded);
          img.removeEventListener("error", checkAllImagesLoaded);
        });
      };
    };

    // Initial check
    checkImages();

    // Set interval to check every second
    const intervalId = setInterval(checkImages, 1000);

    // Cleanup function to clear the interval and remove event listeners
    return () => {
      clearInterval(intervalId);
    };
  }, []);


  useEffect(() => {
    const updateOverviewInfoHeight = () => {
      if (stickyInfo && sectionWidth) {
     

        
    if (stickyInfo.getBoundingClientRect().top < 50) {

          const elementHeight = stickyInfo.getBoundingClientRect().height;
       

          const casesHeight = containerRef.current.getBoundingClientRect().height - 50;
     
    
          //make info-block only sticky, when there is enough room
          if ((casesHeight+elementHeight) < window.innerHeight) {
          
            stickyInfo.classList.add("sticky");
          }
        
    }  
            
    
       
   
       
      }
    };

    updateOverviewInfoHeight();

    window.addEventListener("scroll", updateOverviewInfoHeight);

    return () => {
  
      window.removeEventListener("scroll", updateOverviewInfoHeight);
    };
  }, [stickyInfo, containerRef, sectionWidth, items]);

  return (
    <div
      style={{
        marginLeft: (sectionWidth ? gap : 0) + "px",
        marginRight: (sectionWidth ? gap * 3 : 0) + "px",
      }}
    >
      <div
        ref={containerRef}
        style={{ gap: gap + "px" }}
        className={
          " v-items-center " +
          (sectionWidth
            ? "v-flex carousel-container "
            : "v-px-mobile v-opacity-0 v-flex  v-overflow-hidden sm:v-px-medium xl:v-max-w-desktop v-mx-auto")
        }
      >
        {shuffledItems.length > 0 && panelsRef?.current ? (
          shuffledItems.map((entity, index) => {
            return (
              <div
                key={index}
                style={{
                  flex: "0 0 auto",
                  width: `${sectionWidth ? sectionWidth + "px" : "100%"}`,
                }}
                className={
                  (sectionWidth ? "" : "lg:v-w-1/2 v-w-full") +
                  " " +
                  (index % 2 ? "md:v-mt-20" : "")
                }
                ref={(el) => (panelsRef.current[index] = el)}
                dangerouslySetInnerHTML={{
                  __html: teasers[entity.nid],
                }}
              />
            );
          })
        ) : (
          <div className={"no-results v-p-4 v-transition-none"}>
            {labels["nothing"]}
          </div>
        )}
      </div>
    </div>
  );
};

export default Grid;
